import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/store'
import Vuex from 'vuex'
import firebase from 'firebase'
import 'firebase/firestore'
import VueFire from 'vuefire'
import firebaseConfig from './components/firebaseConfig.js'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

Vue.config.productionTip = false

Vue.use(VueFire)
Vue.use(Vuex)
Vue.use(Vuetify)

let app

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
var provider = new firebase.auth.GoogleAuthProvider();

firebase.auth().onAuthStateChanged(function(user) {
  if (!app) {
    app = new Vue({
      el: '#app',
      template: '<App/>',
      components: { App },
      router,
      render: h => h(App),
      data() {
      },
      methods: {

      }
    })
  }
})

export default firebaseApp.firestore()
